import { useEffect, useMemo } from 'react'
import useMobileDetect from 'use-mobile-detect-hook'

import { useAccounts, UseAccountsReturn } from '../../hooks/use-accounts'
import { AccountsList, AccountsListProps } from './accounts-list'

export function AccountsListContainer({ ...props }: AccountsListProps) {
    const detectMobile = useMobileDetect()
    const { accounts, groupedByAccounts, loading } = useAccounts({
        type: undefined,
        groupBy: props.groupBy,
        currency: props.currency,
    }) as UseAccountsReturn
    const [currency, selectedAccount, onClick] = useMemo(
        () => [props.currency, props.selectedAccount, props.onClick],
        [props],
    )

    useEffect(() => {
        if (currency && !selectedAccount) {
            if (groupedByAccounts[currency] && detectMobile.isDesktop()) {
                //@ts-ignore
                onClick(groupedByAccounts[currency][0])
            }
        }
    }, [currency, selectedAccount, onClick, groupedByAccounts, detectMobile])

    return (
        <AccountsList
            {...props}
            accounts={accounts}
            groupedByAccounts={groupedByAccounts}
            loading={loading}
        />
    )
}
